<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="login">Логин</label>
    <input
      type="text"
      class="form-control"
      id="login"
      placeholder="Введите логин"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'login-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?7b2380f3